var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-page client-profiles-page",
      class: {
        "client-profiles-dynamic": _vm.isDynamicView || _vm.isChartView,
        "client-profiles-classic": _vm.isClassicView,
      },
    },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            {
              staticClass: "col-12 form-page px-md-5 d-flex flex-column h-100",
            },
            [
              _c("client-board-header", {
                attrs: { loading: _vm.loading },
                on: {
                  "changelog-summary": _vm.handleChangelogSummary,
                  "change-board": _vm.handleChangeBoard,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "client-profiles-container",
                  class: { "vertical-flex-container": _vm.isDynamicView },
                },
                [
                  _vm.isDynamicView
                    ? _c("client-board-dynamic-container", {
                        attrs: { loading: _vm.loading },
                      })
                    : _vm.isClassicView
                    ? _c("client-board-classic-container", {
                        attrs: { loading: _vm.loading },
                      })
                    : _vm.isChartView
                    ? _c("client-board-chart-container", {
                        attrs: { loading: _vm.loading },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("add-state-modal"),
      _vm._v(" "),
      _c("board-details-modal"),
      _vm._v(" "),
      _c("delete-board-modal"),
      _vm._v(" "),
      _c("email-tracking-modal"),
      _vm._v(" "),
      _c("manage-collaborators-modal", {
        on: { "collaborator-change": _vm.handleCollaboratorChange },
      }),
      _vm._v(" "),
      _c("manage-visibility-modal"),
      _vm._v(" "),
      _c("remove-self-as-collaborator-modal"),
      _vm._v(" "),
      _vm.selectedBoardId
        ? _c("board-changelog", {
            attrs: {
              "board-id": _vm.selectedBoardId,
              show: _vm.showBoardChangelog,
            },
            on: {
              "update:show": function ($event) {
                _vm.showBoardChangelog = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }